( function( $, window ) {
    'use strict';

	var $sectionMenu;
	var $sectionMenuTrigger;
	var $sectionMenuBody;
	var $sidebar;
	var $sectionMenuLink;
	var resizeTimer;

	var $section = $( '.js-flexible-section' );
	var activeClassName = 'is-active';
	var currentClassName = 'is-current';

	function registerClickHandler() {
		$sectionMenuTrigger.on( 'click.qrc.sectionmenu', function( event ) {
			event.preventDefault();
			$( this ).toggleClass( activeClassName );
			$sectionMenuBody.slideToggle();
		} );
	}

	function registerMenuItemClickHandler() {
		$sectionMenuLink.on( 'click.qrc.sectionmenu.link', function() {
			$sectionMenuTrigger.removeClass( activeClassName );
			$sectionMenuBody.slideUp();
		} );
	}

	function highlightMenuItem( id ) {
		var $sectionMenuItem = $( '.js-section-menu-item' );

		if ( 'undefined' !== typeof id && '' !== id ) {
			$sectionMenuItem.removeClass( currentClassName );
			$sectionMenuItem.find( 'a[href="#' + id + '"]' ).parent().addClass( currentClassName );
			$sectionMenuTrigger.find( '.js-section-menu-trigger-label' ).text( $sectionMenuItem.find( 'a[href="#' + id + '"]' ).text() );
		}
	}

	function registerWaypoints() {
		$section.each( function() {
			$( this ).waypoint( {
				handler: function ( direction ) {
					if ( 'down' === direction ) {
						highlightMenuItem( this.element.id );
					}
				},
				offset: '100px'
			} );
			$( this ).waypoint( {
				handler: function ( direction ) {
					if ( 'up' === direction ) {
						highlightMenuItem( this.element.id );
					}
				},
				offset: '-50%'
			} );
		} );
	}

	function positionMenu() {
		if ( $( window ).scrollTop() > $sidebar.offset().top ) {
			$sectionMenu.addClass( 'is-fixed' );
		} else {
			$sectionMenu.removeClass( 'is-fixed' );
		}
	}

	function registerScrollHandler() {
		$( window ).on( 'scroll.qrc.coursemenu', function() {
			positionMenu();
		} );
	}

	function registerResizeHandler() {
		$( window ).on( 'resize.qrc.coursemenu', function() {
			clearTimeout( resizeTimer );
			resizeTimer = setTimeout( function() {
				positionMenu();
			}, 250 );
		} );
	}

    $( function() {
	    $sectionMenu = $( '.js-section-menu' );
	    $sectionMenuTrigger = $( '.js-section-menu-trigger' );
	    $sectionMenuBody = $( '.js-section-menu-body' );
	    $sidebar = $( '.js-course-sidebar' );
	    $sectionMenuLink = $( '.js-section-menu-link' );

	    if ( $sectionMenu.length ) {
		    registerWaypoints();
	    }

	    enquire.register( '(max-width: 1023px)', {
	    	match: function() {
			    if ( $sectionMenu.length ) {
				    registerClickHandler();
				    registerScrollHandler();
				    registerResizeHandler();
				    registerMenuItemClickHandler();
				    positionMenu();
			    }
		    },
		    unmatch: function() {

		    }
	    } );

	    enquire.register( '(min-width: 1024px)', {
	    	match: function() {
			    if ( $sectionMenu.length ) {
				    registerWaypoints();
				    $( window ).off( 'scroll.qrc.coursemenu' );
				    $( window ).off( 'resize.qrc.coursemenu' );
				    $sectionMenuTrigger.off( 'click.qrc.sectionmenu' );
				    $sectionMenu.removeClass( 'is-fixed' );
				    $sectionMenuLink.off( 'click.qrc.sectionmenu.link' );
			    }
		    }
	    } );
    } );
} )( jQuery, window );
